import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';

import { PurchasePartyService } from '../../../services/index';
import { PurchasePartyModel } from '../../../model/index';

@Component({
    selector: 'add-edit-purchase-party-window',
    templateUrl: './addEditPurchaseParty.component.html'
})
export class AddEditPurchasePartyComponent implements OnInit {
    title: string;
    public mode: string;
    public list: any[] = [];

    @Input() purParData: PurchasePartyModel[] = [];
    @Output() purchasePartyLoadEvent = new EventEmitter();
    // trigger-variable for Ladda
    isLoading: boolean = false;
    typeCtrl: FormControl;
    typeList = [];

    constructor(private referenceService: PurchasePartyService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) {

        this.typeCtrl = new FormControl();
    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#purchase_party_name').focus();
        }, 100);
    }

    onSaveReference(): void {
        let that = this;
        // data = {
        // 	mode: this.purParData['mode']
        // };
        this.isLoading = true;
        this.referenceService
            .addUpdatePurchaseParty(this.purParData)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.purchasePartyLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/purchaseParty/addEditPurchaseParty.component.ts